import { SVGProps } from 'react';

const Unlink2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 7h2a5 5 0 1 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2"
    />
  </svg>
);
export default Unlink2;
